/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { getWindowsConfigurations } from "../../utils/Utils";
import Bauhaus2w2l from "../Models/Bauhaus2w2l";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF("/glbs/Cena-Slim.glb");
  const [wallWidth, setWallWidth] = useState(props.configuration.width);
  const [wallHeight, setWallHeight] = useState(props.configuration.height);
  const [originalHeight, setOriginalHeight] = useState(
    props.configuration.originalHeight
  );
  const [originalWidth, setOriginalWidth] = useState(
    props.configuration.originalWidth
  );

  const [leftMount, setLeftMount] = useState({ h: 0, v: 0 });
  const [rightMount, setRightMount] = useState({ h: 0, v: 0 });

  const {
    position: pos,
    horizontalMount: horiz,
    verticalMount: vert,
  } = props.wingConfiguration;

  useEffect(() => {
    const defaultConfig = { h: 0, v: 0 };
    setLeftMount(defaultConfig);
    setRightMount(defaultConfig);
  }, [props.currentWindow]);

  useEffect(() => {
    switch (pos) {
      case "left-wing":
        setLeftMount({ h: horiz, v: vert });
        break;
      case "right-wing":
        setRightMount({ h: horiz, v: vert });
        break;
      default:
        break;
    }
  }, [props.wingConfiguration]);

  useEffect(() => {
    setWallWidth(props.configuration.width);
    setWallHeight(props.configuration.height);
    setOriginalHeight(props.configuration.originalHeight);
    setOriginalWidth(props.configuration.originalWidth);
  }, [props.configuration]);

  const material = nodes["Plane003"].material;
  material.color.set("#161616");

  // const material2 = nodes["right"].material;
  // material2.color.set(props.color);

  const windowsSettings = {
    sizes: {
      horizontal: originalHeight,
    },
    coeficients: {
      horizontal: 0.95,
    },
  };

  const windowsConfigurations = getWindowsConfigurations({
    settings: windowsSettings,
    mountings: [
      { orientation: "horizontal", position: "left", mount: leftMount.h },
      { orientation: "horizontal", position: "right", mount: rightMount.h },
    ],
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        name="Plane003"
        position={[0, 0, -0.07]}
        castShadow
        receiveShadow
        geometry={nodes.Plane003.geometry}
        material={materials["Wall internal"]}
        morphTargetDictionary={nodes.Plane003.morphTargetDictionary}
        morphTargetInfluences={[wallWidth - 0.02, wallHeight - 0.1]}
      />
      <mesh
        name="Plane003_1"
        position={[0, 0, -0.07]}
        castShadow
        receiveShadow
        geometry={nodes.Plane003_1.geometry}
        material={materials["Wall external"]}
        morphTargetDictionary={nodes.Plane003_1.morphTargetDictionary}
        morphTargetInfluences={[wallWidth - 0.02, wallHeight - 0.1]}
      />
      <Bauhaus2w2l
        wallWidth={wallWidth}
        wallHeight={wallHeight}
        originalWidth={originalWidth}
        originalHeight={originalHeight}
        leftMount={leftMount}
        rightMount={rightMount}
        color={props.color}
        position={[0.015, 0, -0.05]}
      />
      <group position={[-0.02, 0.01, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane001.geometry}
          material={materials["External Floor"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane001_1.geometry}
          material={materials["Floor "]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane001_2.geometry}
          material={materials["Floor internal"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Plane001_3.geometry}
          material={materials["Metal"]}
        />
     </group>
    </group>
  );
}

useGLTF.preload("/glbs/Cena-Slim.glb");
